import { InteractiveEducationLayout } from './InteractiveEducationLayout';
import { useInteractiveEducation } from '../hooks/useInteractiveEducation';
import { useInteractiveEducationProps } from '../hooks/useInteractiveEducationProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoContentWithInteractiveEducation = ({
  lessonContentId,
  contentType,
  videoId,
  contentPortalId,
  videoTitle,
  interactiveContentTrackingProps,
  children,
  primaryContentId
}) => {
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled
  } = useInteractiveEducation({
    videoId,
    interactiveContentTrackingProps
  });
  const interactiveEducationProps = useInteractiveEducationProps({
    primaryContentId,
    contentType,
    lessonContentId,
    interactiveContentTrackingProps
  });
  return /*#__PURE__*/_jsx(InteractiveEducationLayout, {
    contentPortalId: contentPortalId,
    contentType: contentType,
    displayInteractiveEducation: displayInteractiveEducation,
    interactiveContentTrackingProps: interactiveContentTrackingProps,
    interactiveEducationEnabled: interactiveEducationEnabled,
    interactiveEducationProps: interactiveEducationProps,
    lessonContentId: lessonContentId,
    primaryContentId: primaryContentId,
    videoId: videoId,
    videoTitle: videoTitle,
    children: children({
      displayInteractiveEducation,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled,
      generateQuizLoading: interactiveEducationProps.generateQuizLoading
    })
  });
};
export default VideoContentWithInteractiveEducation;